module.exports = __webpack_public_path__ + "img/watch.06dd7ae6.svg";